
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "arrow_down",
  "use": "arrow_down-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"arrow_down\"><path d=\"M37.242 17.447c-.117-.766-.85-1.39-1.625-1.38H12.31c-1.258-.016-2.068 1.791-1.218 2.72l11.694 12.67c.605.636 1.75.636 2.356 0l11.694-12.67a1.65 1.65 0 00.407-1.34z\" /></symbol>"
});
    sprite.add(symbol);

    export default class ArrowDownSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="arrow_down" {...this.props} />;
      }
    }
  